import { Suspense, lazy, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { bootstrapSession, hasToken } from "./lib/api";
import Layout from "./components/Layout";
import Portal from "./pages/Portal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Participants from "./pages/Participants";
import Roster from "./pages/Roster";
import Billing from "./pages/Billing";
import Team from "./pages/Team";
import Compliance from "./pages/Compliance";
import Homes from "./pages/Homes";
import HomeDetail from "./pages/HomeDetail";
import HR from "./pages/HR";
import Quality from "./pages/Quality";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
// The Stream SDK is ~300 kB; only chat users should pay for it.
const Chat = lazy(() => import("./pages/Chat"));
import PublicPage, { PublicIndex } from "./pages/PublicPage";
import Marketing from "./pages/Marketing";
import ParticipantDetail from "./pages/ParticipantDetail";

function Protected({ children }: { children: React.ReactNode }) {
  return hasToken() ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  const [restoring, setRestoring] = useState(true);
  useEffect(() => { bootstrapSession().finally(() => setRestoring(false)); }, []);
  if (restoring) return <div className="min-h-screen grid place-items-center text-mut text-sm">Loading…</div>;
  return (
    <Routes>
      {/* Public marketing site — no session required (FR-TEN-07). */}
      <Route path="/site" element={<Marketing />} />
      <Route path="/site/pages" element={<PublicIndex />} />
      <Route path="/site/:slug" element={<PublicPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/portal" element={<Protected><Portal /></Protected>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/participants" element={<Participants />} />
        <Route path="/participants/:id" element={<ParticipantDetail />} />
        <Route path="/roster" element={<Roster />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/team" element={<Team />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/homes" element={<Homes />} />
        <Route path="/homes/:id" element={<HomeDetail />} />
        <Route path="/hr" element={<HR />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/messages" element={
          <Suspense fallback={<div className="text-sm text-mut">Loading messages…</div>}>
            <Chat />
          </Suspense>
        } />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
